import { PATH } from "../constant";
import { noAuthApiService } from "./api.service";

async function getMemberVoucher(body: any) {
  return await noAuthApiService.post(PATH.CART.GET_MEMBER_VOUCHER, body);
}

async function checkVoucher(body: any) {
  return await noAuthApiService.post(PATH.CART.CHECK_VOUCHER, body);
}


export const cartService = {
  getMemberVoucher,
  checkVoucher,
};
